import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LogueadoComponent } from "./logueado.component";
import { LogueadoRoutingModule } from "./logueado-routing.module";
import { TareaNotificacionComponent } from "../../components/notificaciones/tarea-notificacion/tarea-notificacion.component";
import { NotificacionComponent } from "../../components/notificaciones/notificacion/notificacion.component";
import { SimpleNotificationsModule } from "angular2-notifications";
import { ToolbarComponent } from "../../components/toolbar/toolbar.component";
import { CalendarioComponent } from "../../components/calendario/calendario.component";
import { ModulosComponent } from "../../components/toolbar/modulos/modulos.component";
import { CambiarContrasenaComponent } from "../../forms/usuarios/cambiar-contrasena/cambiar-contrasena.component";
import { ThemeEmitterComponent } from "../../components/tema/theme-emitter.component";
import { NgxPermissionsModule } from "ngx-permissions";
import { TareaService } from "../../providers/tarea.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { CambiarContrasenaDialog } from "../../forms/usuarios/cambiar-contrasena/cambiar-contrasena-dialog/cambiar-contrasena-dialog.component";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { UsuarioService } from "../../providers/usuario.service";
import { MatSelectSearchModule } from "../../components/mat-select-search/mat-select-search.module";
import { CotizacionService } from "../../providers/cotizacion.service";
import { TareaResponsableService } from "../../forms/tareas/tarea-responsables/tarea-responsable/tarea-responsables.service";
import { DetalleService } from "../../providers/detalle.service";
import { TareaModule } from "../../forms/tareas/tarea.module";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { NotificacionService } from "../../providers/notificacion.service";
import { PersonasModule } from "../../components/personas/personas.module";
import { AlertasModule } from "../../components/alertas/alertas.module";
import { AlertasService } from "../../providers/alertas.service";
import { ConfiguracionEmpresaService } from "../../providers/configuracion-empresa.service";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        LogueadoRoutingModule,
        SimpleNotificationsModule.forRoot({
            position: ["bottom", "left"]
        }),
        NgxPermissionsModule.forChild(),
        MatSelectSearchModule,
        TareaModule,
        MaterialModule,
        PipesModule,
        PersonasModule,
        AlertasModule
    ],
    declarations: [
        LogueadoComponent,
        TareaNotificacionComponent,
        NotificacionComponent,
        ToolbarComponent,
        CalendarioComponent,
        ModulosComponent,
        CambiarContrasenaComponent,
        ThemeEmitterComponent,
        CambiarContrasenaDialog,
    ],
    providers: [
        TareaService,
        NotificacionService,
        DeviceDetectorService,
        UsuarioService,
        CotizacionService,
        TareaResponsableService,
        DetalleService,
        AlertasService,
        ConfiguracionEmpresaService
    ],
    entryComponents: [
        CambiarContrasenaDialog
    ]
})
export class LogueadoModule { }